import IdView from "@components/idView";
import React from "react";
import { Content, ContentDescription, ContentTitle } from "../baseItems";
import Base from "./base";

export default class STP extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			clabe: "",
		};

		props.externalFunc.makeDeposit({}, (data) => {
			if (data && data.clabe) {
				this.setState({ clabe: data.clabe });
			}
		});
	}

	getStep1(translate) {
		const { clabe } = this.state;
		return (
			<Content>
				<ContentTitle data-testid="step-deposit-amount-title">{translate("CLABE_CODE")}</ContentTitle>
				<p>
					{clabe && (
						<IdView
							length={18}
							color="white"
							id={clabe}
						/>
					)}
				</p>
				<ContentDescription>{translate("CLABE_CODE_DESC")}</ContentDescription>
			</Content>
		);
	}
}
